import request from '@/utils/request'

// 获取教师信息
export const GetTeacherAPI = (data) => request.get('/users/teachers/', { params: data })

// 删除教师
export const DelTeacherAPI = (id) => request.delete(`/users/teachers/${id}/`)

// 删除全部老师
export const DelAllTeaAPI = () => request.delete('/users/del_all_teacher/')

// 批量导入 上传文件 (教师)
export const ImportUploadFileTeaApI = (data) => request.post('/users/import_teachers/', data)

// 批量导出教师
export const BatchExportTeaAPI = () => request.get('/users/get_excel_teacher/')

// 添加老师
export const AddTeacherAPI = (data) => request.post('/users/teachers/', data)

// 获取编辑老师的详情
export const GetTeaDetailAPI = (id) => request.get(`/users/teachers/${id}/`)

// 更新老师的信息
export const PutTeacherAPI = (data) => request.put(`/users/teachers/${data.id}/`, data)
